/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");

var xtend = require("xtend");

module.exports = Model({
	name: "managedpreferences",
	init: init,
	listeners: listeners,
	triggers: triggers,

	reset: reset,
});

function init() {
	this.reset();
}

function reset() {
	this.push({
		data: {
			_id: "",

			available: "",

			fname: "",
			lname: "",

			language: "",
			gender: "",

			dob: "",

			city: "",
			province: "",
			country: "",
		}
	});
}

function listeners() {
	return {
		"managedaccount:updated": handle_managed_account_update,
	};
}

function triggers() {
	return {
		"view": handle_trigger_open, // The page has been opened, reset to defaults
		"update": handle_trigger_update, // The info should be updated, call API
	};
}

function handle_trigger_open(data) {
	var who = data.who;
	var group = data.group;
	this._who = who;
	this._group = group;
	this.dispatch("viewing");
	this.emit("usermetrics:trigger:track", "view managed user's personal information", {
		who,
	});
}

function handle_managed_account_update(managedaccount) {
	var open = managedaccount.open;

	if (!open) return this.reset();

	var data = managedaccount.data;

	this.extend({
		data: data,
	});
}

function handle_trigger_update(data) {
	this.emit("save:trigger:start");

	var dob_string = "";

	if(data.dob){
		dob_string = (new Date(data.dob)).toISOString();
	}

	data.dob = dob_string;

	var id = this._who;
	var group = this._group;

	var fname = data.fname;
	var lname = data.lname;
	if(fname || lname){
		if(!lname)
			data = xtend(data, {
				lname: this.data.data.lname
			});
		if(!fname)
			data = xtend(data, {
				fname: this.data.data.fname
			});
	}

	if(typeof data.searchHidden === "string")
		data = xtend(data, {
			searchHidden: data.searchHidden === "true"
		});

	var message = "managedprofile.saved";
	this.emit("toast:trigger:show", {
		content: message
	});

	this.api.manage.update(data, id, group)
		.then(handle_update_success.bind(this))
		.catch(handle_update_error.bind(this));
}

function handle_update_success() {
	this.emit("save:trigger:finish");
	this.dispatch("newsettings", {
		who: this._who,
		section: "personal",
		timestamp: new Date().toISOString(),
	});
}

function handle_update_error(error) {
	this.emit("save:trigger:finish");
	var code = error.code;

	var toastMessage = "";

	if (code === 0){ // Network is down
		toastMessage = "managedprofile.errorNetwork";
	}else if (code === 403){ // Not managing this person (how did we even get here O.O
		// TODO: Add toast message here
	}else if (code === 400){ // Something was wrong with the input format
		toastMessage = "managedprofile.errorformat";
	}

	this.emit("toast:trigger:show", {
		content: toastMessage,
		style: "error"
	});

}